import { render, staticRenderFns } from "./benefits-tier-card.vue?vue&type=template&id=05fd63ac&scoped=true"
import script from "./benefits-tier-card.vue?vue&type=script&lang=js"
export * from "./benefits-tier-card.vue?vue&type=script&lang=js"
import style0 from "./benefits-tier-card.vue?vue&type=style&index=0&id=05fd63ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd63ac",
  null
  
)

export default component.exports